import { render, staticRenderFns } from "./level-card.vue?vue&type=template&id=8f24064c&scoped=true&"
import script from "./level-card.vue?vue&type=script&lang=ts&"
export * from "./level-card.vue?vue&type=script&lang=ts&"
import style0 from "./level-card.vue?vue&type=style&index=0&id=8f24064c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f24064c",
  null
  
)

export default component.exports